import React from 'react';
import { ActivityIndicator } from 'react-native';
import { Theme, ThemedView } from '@app/theme';
import { useTheme } from '@shopify/restyle';

const PageLoader: React.FC<any> = () => {

    const { colors } = useTheme<Theme>();
    return (
        <ThemedView backgroundColor="bg-surface-primary" justifyContent={"center"} alignItems={"center"} flex={1}>
            <ActivityIndicator size={12} color={colors['icon-action-primary']} />
        </ThemedView>
    );
};

export default PageLoader;
